export default __webpack_public_path__ + "static/media/vki-fr.7a829264.pdf";